const ActionTypes = {
  SHOW_MENU_BUTTON: 'SHOW_MENU_BUTTON'
}

export default ActionTypes;
